<template>
    <div v-if="order.totalPharma || order.totalPara" class="row bg-light text-danger pr-2 pl-2">
      <div class="col-8 text-left">
        <div>
          Commande : <span class="font-weight-bold ml-1">{{ order.linesCount }} articles</span>,
          Total Qté : {{ order.allQtyCount }} unités
        </div>
      </div>
  
      <div class="col-2 text-right">
        <div>Total HT MED : <span class="font-weight-bold ml-1">{{ order.totalPharma }}</span></div>
      </div>
  
      <div class="col-2 text-right">
        <div>Total HT PARA : <span class="font-weight-bold ml-1">{{ order.totalPara }}</span></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      order: {
        type: Object,
        required: true
      }
    }
  };
  </script>
  